import React from "react";
import { Dialog } from "@blueprintjs/core";
import moment from "moment";
import { I18n } from "react-redux-i18n";
import BookingForm from "./BookingForm";
import UsersBookings from "./UsersBookings";
import ProductRentalForm from "../../components/ProductRental/ProductRentalForm";

const BookingDetails = ({
  isOpen,
  handleOnClose,
  bookings,
  booking_stats,
  myGuid,
  deleteBooking,
  deleting_booking,
  saveBooking,
  saving_booking,
  selected_date,
  past_date,
  circleId,
  rentals
}) => {
  const show_bookings = bookings && bookings.length > 0;
  let show_form = false;
  if (!past_date) {
    const current_selected_date = moment(selected_date).format("YYYY-MM-DD");
    if (booking_stats && booking_stats[current_selected_date]) {
      if (!booking_stats[current_selected_date].is_full_day) {
        show_form = true;
      }
    }
  }

  const BookingClock = rentals ? ProductRentalForm : BookingForm;

  return (
    <Dialog
      onClose={handleOnClose}
      title={I18n.t("booking.user_booking")}
      autoFocus={true}
      canEscapeKeyClose={true}
      canOutsideClickClose={true}
      enforceFocus={true}
      isOpen={isOpen}
      usePortal={true}
      className="booking-details">
      {show_bookings && (
        <UsersBookings
          past_date={past_date}
          bookings={bookings}
          myGuid={myGuid}
          deleteBooking={deleteBooking}
          deleting_booking={deleting_booking}
        />
      )}
      {(show_form || !show_bookings) &&
        <BookingClock
          selected_date={selected_date}
          handleOnClose={handleOnClose}
          saveBooking={saveBooking}
          saving_booking={saving_booking}
          circleId={circleId}
        />
      }
    </Dialog>
  );
};

export default BookingDetails;